import ISelection from '@models/betSlip/ISelection';

export function getNonFixedSelectionsCount(selections: ISelection[]): number {
    return selections
        .filter((s) => !s.isFixed)
        .filter((s) => s.odd?.isShownOnOffer)
        .length;
}
